import {
  Actions,
  type Preset,
  type PublishContent,
  type PublishData,
  type PublishFonts,
  type PublishPresets,
  type TabInfo,
} from '@storeOld/reducers/publish/types'
import type { Dispatch } from 'redux'

export const setPublishData = (payload: PublishData | null) => ({
  type: Actions.SET_PUBLISH_DATA,
  payload,
})

export const removePublishData = () => ({
  type: Actions.REMOVE_PUBLISH_DATA,
  payload: null,
})

export const setPublishRemovePresetName = () => ({
  type: Actions.SET_PRESET_NAME,
  payload: null,
})

export const setPublishFont = (payload: PublishFonts) => ({
  type: Actions.SET_FONT,
  payload,
})

export const setPublishContent = (payload: PublishContent) => ({
  type: Actions.SET_CONTENT,
  payload,
})

export const setPublishBgColor = (payload: string) => ({
  type: Actions.SET_BG_COLOR,
  payload,
})

const setPublishPresetName = (payload: PublishPresets) => ({
  type: Actions.SET_PRESET_NAME,
  payload,
})

export const setPreset = (payload: Preset) => (dispatch: Dispatch<any>) => {
  dispatch(setPublishFont(payload.font))
  dispatch(setPublishContent(payload.content))
  dispatch(setPublishBgColor(payload.bgColor))
  dispatch(setPublishPresetName(payload.name))
}

export const setPublishPagePreview = (payload: boolean) => ({
  type: Actions.SET_PAGE_PREVIEW,
  payload,
})

export const setPublishTabInfo = (payload: TabInfo) => ({
  type: Actions.SET_TAB_INFO,
  payload,
})

export const setPublishSearchEngine = (payload: boolean) => ({
  type: Actions.SET_SEARCH_ENGINE,
  payload,
})

export const setPublishBranding = (payload: boolean) => ({
  type: Actions.SET_BRANDING,
  payload,
})
